import { render, staticRenderFns } from "./blacklistRecordsDetail.vue?vue&type=template&id=5db65ee2&scoped=true"
import script from "./blacklistRecordsDetail.vue?vue&type=script&lang=js"
export * from "./blacklistRecordsDetail.vue?vue&type=script&lang=js"
import style0 from "./blacklistRecordsDetail.vue?vue&type=style&index=0&id=5db65ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db65ee2",
  null
  
)

export default component.exports